import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { decompress } from 'compress-json';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GlobalStoreService {
  private membersDetails = []
  private customerFormConfig : any = {};
  private corporateFormConfig : any = {};
  private brokerFormConfig : any = {};
  private corporateSignupFormConfig : any = {};

  constructor(private http: HttpClient) { }

  getMemberDetails() {
    return this.membersDetails ?? [];
  }

  setMemberDetails(data?: any) {
    if (this.membersDetails.length === 0 || data.length == 0) {
      this.fetchMembers();
    }

    if (data && data !== undefined && data !== null) {
      this.membersDetails = data;
      return;
    }
  }

  getCustomerFormConfig() {
    return this.customerFormConfig;
  }

  getCorporateFormConfig(){
    return this.corporateFormConfig;
  }

  getBrokerFormConfig(){
    return this.brokerFormConfig;
  }

  getCorporateSignupFormConfig(){
    return this.corporateSignupFormConfig;
  }

  setCustomerFormConfig(lang?: any, data?: any) {
    console.log('asdf',data,Object.keys(this.customerFormConfig).length)
    if (data==undefined || Object.keys(this.customerFormConfig)?.length === 0 && Object.keys(data)?.length == 0) {
      this.fetchCustomerFormConfig(lang ?? 'en');
    }

    if (data && data !== undefined && data !== null) {
      this.customerFormConfig = data;
      return;
    }
  }

  fetchMembers() {
    var accessToken = sessionStorage.getItem('accessToken');
    const role = sessionStorage.getItem('role')
    let getClients = ''
    if (role == 'ADMINISTRATOR') {
      getClients = '/api/ap/global/adminMembers';
    } else {
      getClients = '/api/ap/admin/customers/list';
    }
    this.http
      .get(environment.apiUrl + getClients, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {

          if (response['status'] == 200 || response['statusCode'] == 200) {
            let members: any;
            if (role == 'ADMINISTRATOR') {
              members = decompress(response.data)
            } else {
              members = response.data.map(res => {
                return {
                  ...res,
                  username: res.user?.username,
                  primaryPhone: res?.contactInformations?.[0]?.primaryPhone || '',
                }
              })
            }
            let filterStatus = [];
            console.log("status", filterStatus);
            members.sort((a, b) => {
              const order = { Active: 1, Draft: 2, Suspended: 3, Hold: 4, Cancelled: 5, Incomplete: 6 };

              if (order[a.status] !== order[b.status]) {
                return order[a.status] - order[b.status];
              }
              const result = a.firstName.localeCompare(b.firstName);
              return result !== 0 ? result : a.lastName.localeCompare(b.lastName);
            });
            this.membersDetails = members
            console.log('set store member details', this.membersDetails)
          }
        },
      );
  }

  fetchCustomerFormConfig(lang) {
    let accessToken = sessionStorage.getItem('accessToken');
    let customerDataEndpoint = '/customer/formConfig';
  
    try {
      this.http.get(environment.apiUrl + '/api/ap' + customerDataEndpoint, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
          'Lang': lang,
        }
      }).subscribe((response: any)=>{
        if (response.status === 200) {
          this.customerFormConfig = response.data;
        }
      })
  
    } catch (error) {
      console.error('Error fetching customer form config:', error);
    }
  }

  setFormConfig(form:any,lang?:any,data?:any){
    console.log('set form config',form,data,Object.keys(this.customerFormConfig).length)
    if (data==undefined || Object.keys(this.customerFormConfig)?.length === 0 && Object.keys(data)?.length == 0) {
      this.fetchFormConfig(form,lang ?? 'en');
    }

    if (data && data !== undefined && data !== null) {
      switch(form){
        case 'customer':
          this.customerFormConfig = data;
          break;
        
        case 'corporate':
          this.corporateFormConfig = data;
          break;

        case 'broker':
          this.brokerFormConfig = data;
          break;
        
        case 'corporateSignup':
          this.corporateSignupFormConfig = data;
          break;
        
        default:
          console.log('form didnt match with any',form)
          break;
      }
      return;
    }
  }

  fetchFormConfig(form,lang) {
    console.log('set form config api call', form, lang)
    let accessToken = sessionStorage.getItem('accessToken');
    let customerDataEndpoint = `/${form}/formConfig`;
  
    try {
      this.http.get(environment.apiUrl + '/api/ap' + customerDataEndpoint, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
          'Lang': lang,
        }
      }).subscribe((response: any)=>{
        if (response.status === 200) {
          const data = response.data;
          switch(form){
            case 'customer':
              this.customerFormConfig = data;
              break;
            
            case 'corporate':
              this.corporateFormConfig = data;
              break;
    
            case 'broker':
              this.brokerFormConfig = data;
              break;
            
            case 'corporateSignup':
              this.corporateSignupFormConfig = data;
              break;
            
            default:
              console.log('form didnt match with any',form)
              break;
          }
        }
      })
    } catch (error) {
      console.error('Error fetching form config:', form, error);
    }
  }
}
